import React, { useEffect, useState } from 'react'
import { Row, Toggle } from 'rsuite'

export default function DashboradToggle({
  onChange = () => {},
  checked,
  dashboradName,
  checkedChildren = 'แสดง',
  unCheckedChildren = 'ซ่อน',
  align = 'left',
  style = { marginTop: 20 },
}) {
  const [isCheck, setIsCheck] = useState()

  useEffect(() => {
    setIsCheck(checked)
  }, [checked])

  return (
    <Row align={align} style={style}>
      <Toggle
        size="lg"
        defaultChecked={checked}
        checked={isCheck}
        checkedChildren={checkedChildren}
        unCheckedChildren={unCheckedChildren}
        onChange={(value) => {
          setIsCheck(value)
          onChange(value, dashboradName)
        }}
      />
    </Row>
  )
}
